import {
  Component, OnInit, OnDestroy, AfterViewInit,
  ViewChild, ElementRef, NgZone, Renderer2
} from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { LoginFacadeService } from './login-facade.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BehaviorSubject, EMPTY, Observable, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { loginInterface } from 'app/Model/login.Interface';
import { LoginService } from 'app/services/login.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { HttpErrorResponse } from '@angular/common/http';

interface LcDot {
  x: number; y: number;
  vx: number; vy: number;
  r: number;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('lcCanvas') private canvasRef!: ElementRef<HTMLCanvasElement>;

  textoLogin: string = '';
  txtUser: string = '';
  year: number = new Date().getFullYear();

  private response$ = new Subject<loginInterface[]>();
  public responseAction$: Observable<loginInterface[]> = this.response$.asObservable();

  private loading$ = new BehaviorSubject<any>({ loading: false, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
  public responseLoading$: Observable<any> = this.loading$.asObservable();

  private error$ = new BehaviorSubject<any>({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.error$.asObservable();

  public loginForms: FormGroup;
  public hide: boolean = true;

  private animId = 0;
  private mx = -9999;
  private my = -9999;
  private dots: LcDot[] = [];
  private resizeFn = () => this.resizeCanvas();
  private mouseFn = (e: MouseEvent) => { this.mx = e.clientX; this.my = e.clientY; };

  constructor(
    public _loginService: LoginService,
    private _toast: ToastrServiceLocal,
    private _mensajeHttp: MensajesHttpService,
    private _router: Router,
    public loginFacade: LoginFacadeService,
    public router: Router,
    private _renderer: Renderer2,
    private ngZone: NgZone
  ) {
    this.loginForms = new FormGroup({
      usuario:  new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    this._renderer.addClass(document.body, 'login-dark');
    document.documentElement.style.backgroundColor = '#0f1923';
    const parametro = this._loginService.getData('login');
    if (parametro === undefined || parametro === null) {
      this.volver();
    } else {
      if (parametro === "loginP1") {
        this.textoLogin = 'Servicios al docente de posgrado';
        this.txtUser = 'Docente de posgrado';
      } else if (parametro === "loginC2") {
        this.textoLogin = 'Servicios al coordinador de posgrado';
        this.txtUser = 'Coordinador de posgrado';
      } else if (parametro === "loginG3") {
        this.textoLogin = 'Servicios al coordinador general';
        this.txtUser = 'Coordinador general';
      } else if (parametro === "loginDS") {
        this.textoLogin = 'Servicios al DSEP';
        this.txtUser = 'DSEP';
      } else if (parametro === "loginDI") {
        this.textoLogin = 'Servicios al DIPP';
        this.txtUser = 'DIPP';
      } else if (parametro === "loginDSA1") {
        this.textoLogin = 'Servicio de Cordinación DSA';
        this.txtUser = 'Cordinación DSA';
      }

    }
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => this.startCanvas());
  }

  ngOnDestroy() {
    cancelAnimationFrame(this.animId);
    window.removeEventListener('resize', this.resizeFn);
    document.removeEventListener('mousemove', this.mouseFn);
    this._renderer.removeClass(document.body, 'login-dark');
    document.documentElement.style.backgroundColor = '';
  }

  private startCanvas(): void {
    const canvas = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d')!;

    this.resizeCanvas();
    window.addEventListener('resize', this.resizeFn);
    document.addEventListener('mousemove', this.mouseFn);

    const MAX_DIST = 145;
    const MOUSE_R  = 120;

    const tick = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (const d of this.dots) {
        const dx = d.x - this.mx;
        const dy = d.y - this.my;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < MOUSE_R && dist > 0) {
          const f = ((MOUSE_R - dist) / MOUSE_R) * 0.60;
          d.vx += (dx / dist) * f;
          d.vy += (dy / dist) * f;
        }

        const spd = Math.sqrt(d.vx * d.vx + d.vy * d.vy);
        if (spd > 2.5) { d.vx *= 2.5 / spd; d.vy *= 2.5 / spd; }
        d.vx *= 0.976;
        d.vy *= 0.976;

        if (Math.abs(d.vx) < 0.12) d.vx += (Math.random() - 0.5) * 0.055;
        if (Math.abs(d.vy) < 0.12) d.vy += (Math.random() - 0.5) * 0.055;

        d.x += d.vx;
        d.y += d.vy;

        if (d.x < 0) d.x = canvas.width;
        else if (d.x > canvas.width) d.x = 0;
        if (d.y < 0) d.y = canvas.height;
        else if (d.y > canvas.height) d.y = 0;
      }

      for (let i = 0; i < this.dots.length; i++) {
        for (let j = i + 1; j < this.dots.length; j++) {
          const a = this.dots[i], b = this.dots[j];
          const ddx = a.x - b.x, ddy = a.y - b.y;
          const d = Math.sqrt(ddx * ddx + ddy * ddy);
          if (d < MAX_DIST) {
            const alpha = (1 - d / MAX_DIST) * 0.28;
            ctx.strokeStyle = `rgba(200,235,255,${alpha})`;
            ctx.lineWidth = 0.9;
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.stroke();
          }
        }
      }

      for (const d of this.dots) {
        ctx.beginPath();
        ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(210,238,255,0.85)';
        ctx.fill();
      }

      this.animId = requestAnimationFrame(tick);
    };

    tick();
  }

  private resizeCanvas(): void {
    const canvas = this.canvasRef.nativeElement;
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    const n = Math.min(Math.floor((canvas.width * canvas.height) / 11000), 100);
    this.dots = Array.from({ length: n }, () => ({
      x:  Math.random() * canvas.width,
      y:  Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.45,
      vy: (Math.random() - 0.5) * 0.45,
      r:  Math.random() * 1.6 + 0.7
    }));
  }

  login() {
    if (this.loginForms.invalid) {
      this.loginForms.markAllAsTouched();
      return;
    }
    this.loginFacade.login(this.loginForms.value);
  }

  volver() {
    this._router.navigateByUrl('/inicio');
  }

  redirectToForgotPassword(): void {
    window.open('https://mail.unah.edu.hn/RecuperarContrase%C3%B1a/1');
  }
}
